var _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgInfoYellow = function SvgInfoYellow(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 1 0 0 16zm0-1a7.01 7.01 0 0 1-7-7 7.01 7.01 0 0 1 7-7 7.01 7.01 0 0 1 7 7 7.01 7.01 0 0 1-7 7zm0-5.5a.5.5 0 0 0 .5-.5V5a.5.5 0 1 0-1 0v4a.5.5 0 0 0 .5.5zm0 2a.5.5 0 1 0 0-1 .5.5 0 1 0 0 1z",
    fill: "#d1af29",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/infoYellow.38176011.svg";
export { ForwardRef as ReactComponent };